var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('x-status-box',{attrs:{"status":_vm.availability,"statusMap":_vm.statusMap}})
}
var staticRenderFns = []

export { render, staticRenderFns }